import { useEffect } from 'react';

export interface MarkerInfo {
  markerSize: 'normal' | 'large';
  borderColor?: string;
  markerColor?: string;
  textColor?: string;
  text?: string;
  alpha?: number;
  markerType: 'start' | 'end' | 'skip' | 'order' | 'orderEditing' | 'waiting';
  chip?: {
    stacked?: boolean;
    skill?: boolean;
    pickup?: boolean;
    delivery?: boolean;
    time?: boolean;
    completed?: boolean;
  };
}

function getChipStack(obj: any): string[] {
  let stack: string[] = [];
  if (!obj) return stack;
  Object.keys(obj).forEach(x => {
    if (obj[x] === true) stack.push(x);
  });
  return stack;
}

function chipCount(obj?: any): number {
  if (!obj) return 0;
  return Object.values(obj).filter(x => x === true).length;
}

export const DynamicSvg = ({ info, useNewerOutline }: { info: MarkerInfo; useNewerOutline?: boolean }) => {
  return (
    <svg
      width="80"
      height={info.markerSize === 'large' ? 80 : 65}
      viewBox={`0 0 80 ${info.markerSize === 'large' ? 80 : 65}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ opacity: info.alpha ? info.alpha : 1 }}
    >
      <g transform="translate(0, 20)">
        {info.markerSize === 'normal' && !useNewerOutline && (
          <path
            d="M0.5 16.3581V16.3581C0.499467 12.2843 2.09819 8.3737 4.95103 5.46989C7.8029 2.56707 11.6795 0.902915 15.7451 0.835938H16.24C20.3082 0.899015 24.1887 2.56146 27.0438 5.46476C29.8998 8.36898 31.5005 12.2818 31.5 16.3581C31.5 18.5843 31.1778 20.2882 30.4252 21.978C29.6674 23.6792 28.4626 25.3917 26.6512 27.6237C25.9774 28.3817 25.4006 29.0026 24.8745 29.5689C23.162 31.4123 21.9875 32.6766 19.753 36.2096C18.701 37.8633 18.1988 39.5967 17.7991 40.9768C17.7339 41.2016 17.6715 41.417 17.6099 41.6212C17.3833 42.372 17.1785 42.9342 16.9183 43.3133C16.6821 43.6576 16.4232 43.8212 16.0444 43.8359H15.9555C15.5666 43.8211 15.3045 43.6552 15.0684 43.3125C14.8077 42.9343 14.6042 42.3731 14.3801 41.6226C14.3182 41.4156 14.2557 41.1969 14.1904 40.9686C13.7962 39.5904 13.3014 37.8601 12.2547 36.2096L12.2541 36.2087C10.0221 32.7064 8.84278 31.4301 7.14461 29.5921C6.61504 29.0189 6.03499 28.3912 5.35682 27.6242C3.54475 25.3915 2.338 23.6826 1.5784 21.9831C0.824084 20.2954 0.5 18.5918 0.5 16.3581Z"
            fill={info.markerColor}
            stroke={info.borderColor}
            strokeWidth={1}
          />
        )}
        {info.markerSize === 'normal' && useNewerOutline && (
          <>
            <path
              d="M0.5 16.3581V16.3581C0.499467 12.2843 2.09819 8.3737 4.95103 5.46989C7.8029 2.56707 11.6795 0.902915 15.7451 0.835938H16.24C20.3082 0.899015 24.1887 2.56146 27.0438 5.46476C29.8998 8.36898 31.5005 12.2818 31.5 16.3581C31.5 18.5843 31.1778 20.2882 30.4252 21.978C29.6674 23.6792 28.4626 25.3917 26.6512 27.6237C25.9774 28.3817 25.4006 29.0026 24.8745 29.5689C23.162 31.4123 21.9875 32.6766 19.753 36.2096C18.701 37.8633 18.1988 39.5967 17.7991 40.9768C17.7339 41.2016 17.6715 41.417 17.6099 41.6212C17.3833 42.372 17.1785 42.9342 16.9183 43.3133C16.6821 43.6576 16.4232 43.8212 16.0444 43.8359H15.9555C15.5666 43.8211 15.3045 43.6552 15.0684 43.3125C14.8077 42.9343 14.6042 42.3731 14.3801 41.6226C14.3182 41.4156 14.2557 41.1969 14.1904 40.9686C13.7962 39.5904 13.3014 37.8601 12.2547 36.2096L12.2541 36.2087C10.0221 32.7064 8.84278 31.4301 7.14461 29.5921C6.61504 29.0189 6.03499 28.3912 5.35682 27.6242C3.54475 25.3915 2.338 23.6826 1.5784 21.9831C0.824084 20.2954 0.5 18.5918 0.5 16.3581Z"
              fill={info.markerColor}
              stroke={info.borderColor}
              strokeWidth={2}
              clipPath={'url(#clip)'}
              id={'ld'}
            />
            <clipPath id="clip">
              <use xlinkHref={'#ld'} />
            </clipPath>
          </>
        )}
        {info.markerSize === 'large' && !useNewerOutline && (
          <path
            d="M0.5 21.8484V21.8484C0.499261 16.2469 2.71578 10.869 6.67245 6.87491C10.6283 2.88166 16.0066 0.591757 21.6479 0.5H22.3314C27.9764 0.586414 33.36 2.87397 37.3203 6.86784C41.2814 10.8625 43.5007 16.2434 43.5 21.8484C43.5 24.9037 43.0536 27.2528 42.0065 29.5845C40.9541 31.9278 39.284 34.279 36.7897 37.3268C35.8585 38.3657 35.0629 39.215 34.3383 39.9886C31.9867 42.4991 30.3828 44.2114 27.3197 49.0144C25.8883 51.2459 25.2054 53.5828 24.6552 55.4655C24.5653 55.7731 24.4789 56.0686 24.3934 56.3495C24.0824 57.3716 23.7942 58.1637 23.4184 58.7068C23.0667 59.215 22.6595 59.4781 22.0647 59.5H21.9352C21.3275 59.478 20.9155 59.2126 20.5635 58.706C20.1868 58.1638 19.9003 57.3727 19.5926 56.351C19.5068 56.066 19.4202 55.766 19.3301 55.4535C18.7876 53.5734 18.1148 51.2413 16.6908 49.0144L16.6902 49.0135C13.6304 44.2521 12.0197 42.5232 9.68772 40.02C8.95827 39.237 8.15825 38.3783 7.22122 37.3273C4.72628 34.2788 3.05347 31.9326 1.99848 29.5917C0.948911 27.2628 0.5 24.9139 0.5 21.8484Z"
            fill={info.markerColor}
            stroke={info.borderColor}
            strokeWidth={1}
          />
        )}
        {info.markerSize === 'large' && useNewerOutline && (
          <>
            <path
              d="M0.5 21.8484V21.8484C0.499261 16.2469 2.71578 10.869 6.67245 6.87491C10.6283 2.88166 16.0066 0.591757 21.6479 0.5H22.3314C27.9764 0.586414 33.36 2.87397 37.3203 6.86784C41.2814 10.8625 43.5007 16.2434 43.5 21.8484C43.5 24.9037 43.0536 27.2528 42.0065 29.5845C40.9541 31.9278 39.284 34.279 36.7897 37.3268C35.8585 38.3657 35.0629 39.215 34.3383 39.9886C31.9867 42.4991 30.3828 44.2114 27.3197 49.0144C25.8883 51.2459 25.2054 53.5828 24.6552 55.4655C24.5653 55.7731 24.4789 56.0686 24.3934 56.3495C24.0824 57.3716 23.7942 58.1637 23.4184 58.7068C23.0667 59.215 22.6595 59.4781 22.0647 59.5H21.9352C21.3275 59.478 20.9155 59.2126 20.5635 58.706C20.1868 58.1638 19.9003 57.3727 19.5926 56.351C19.5068 56.066 19.4202 55.766 19.3301 55.4535C18.7876 53.5734 18.1148 51.2413 16.6908 49.0144L16.6902 49.0135C13.6304 44.2521 12.0197 42.5232 9.68772 40.02C8.95827 39.237 8.15825 38.3783 7.22122 37.3273C4.72628 34.2788 3.05347 31.9326 1.99848 29.5917C0.948911 27.2628 0.5 24.9139 0.5 21.8484Z"
              fill={info.markerColor}
              stroke={info.borderColor}
              strokeWidth={2}
              clipPath={'url(#clip)'}
              id={'ld'}
            />
            <clipPath id="clip">
              <use xlinkHref={'#ld'} />
            </clipPath>
          </>
        )}
        {info.markerType === 'start' && (
          <path
            d="M14.7529 12.3039H13.1689V23.3919H14.7529V12.3039ZM9.88094 14.7759V13.1679H8.29694V14.7759C8.29694 16.9359 7.38494 19.0479 5.45294 19.8879L6.40094 21.1959C7.75694 20.5719 8.62094 19.4079 9.11294 17.9079C9.60494 19.2639 10.4329 20.3559 11.7289 20.9319L12.6289 19.6479C10.7569 18.8439 9.88094 16.8279 9.88094 14.7759ZM26.56 16.2879V14.9799H25.096V12.3159H23.512V18.9759H25.096V16.2879H26.56ZM22.192 18.5919L22.996 17.3679C21.268 16.7919 20.5 15.5199 20.464 14.2239H22.624V12.9639H16.648V14.2239H18.844C18.808 15.6039 18.028 16.9839 16.228 17.5599L17.056 18.7959C18.352 18.3759 19.192 17.5239 19.684 16.4559C20.164 17.4279 20.992 18.2079 22.192 18.5919ZM17.716 19.4679V20.7279H23.512V23.3799H25.096V19.4679H17.716Z"
            fill="white"
          />
        )}
        {info.markerType === 'end' && (
          <path
            d="M6.01694 15.328L6.55694 16.576C8.72894 16.372 10.0009 15.604 10.5889 14.548C11.1649 15.604 12.4369 16.372 14.6089 16.576L15.1609 15.328C13.0969 15.172 12.0289 14.428 11.7409 13.696H14.6809V12.436H6.50894V13.696H9.43694C9.14894 14.428 8.08094 15.172 6.01694 15.328ZM15.5809 17.272H11.3689V15.94H9.78494V17.272H5.59694V18.532H15.5809V17.272ZM10.5649 19.132C8.16494 19.132 6.73694 19.84 6.73694 21.088C6.73694 22.336 8.16494 23.044 10.5649 23.044C12.9649 23.044 14.4049 22.336 14.4049 21.088C14.4049 19.84 12.9649 19.132 10.5649 19.132ZM10.5649 21.856C9.06494 21.856 8.33294 21.628 8.33294 21.088C8.33294 20.572 9.07694 20.32 10.5649 20.32C12.0529 20.32 12.7969 20.572 12.7969 21.088C12.7969 21.628 12.0649 21.856 10.5649 21.856ZM26.404 20.524H23.98V18.844H25.528V17.572H19.12V16.36H25.276V12.688H17.536V13.948H23.716V15.124H17.548V18.844H18.928V20.524H16.384V21.82H26.404V20.524ZM20.488 20.524V18.844H22.42V20.524H20.488Z"
            fill="white"
          />
        )}
        {info.markerType === 'skip' && (
          <path
            d="M15.6049 20.7999H11.3809V18.7719H14.5129V12.9999H12.9529V14.7159H8.22494V12.9999H6.65294V18.7719H9.79694V20.7999H5.59694V22.0839H15.6049V20.7999ZM8.22494 17.5119V15.9639H12.9529V17.5119H8.22494ZM23.644 13.9119V14.7159H17.56V18.0159H25.516V16.7559H19.18V15.8799H25.252V12.6519H17.548V13.9119H23.644ZM26.404 20.0559V18.7959H16.396V20.0559H18.7V23.3799H20.296V20.0559H22.516V23.3799H24.112V20.0559H26.404Z"
            fill="white"
          />
        )}
        {info.markerType === 'waiting' && info.markerSize === 'normal' && (
          <circle cx="16" cy="16" r="8" fill="#769DFF" fillOpacity="0.3" />
        )}
        {info.markerType === 'waiting' && info.markerSize === 'large' && (
          <circle cx="22" cy="22" r="8" fill="#406EE2" />
        )}
        {info.markerType === 'orderEditing' && (
          <path
            d="M26.8563 28H24.3123L18.9043 19.04H18.8403C18.8509 19.2747 18.8616 19.5253 18.8723 19.792C18.8936 20.048 18.9096 20.3147 18.9203 20.592C18.9309 20.8587 18.9416 21.1307 18.9523 21.408C18.9629 21.6853 18.9736 21.9627 18.9843 22.24V28H17.1443V16.576H19.6723L25.0642 25.472H25.1123C25.1016 25.2587 25.0909 25.0293 25.0803 24.784C25.0696 24.528 25.0589 24.2667 25.0483 24C25.0483 23.7333 25.0429 23.4613 25.0323 23.184C25.0216 22.9067 25.0109 22.64 25.0003 22.384V16.576H26.8563V28Z"
            fill="white"
          />
        )}
      </g>

      <g transform={`translate(${info.markerSize === 'large' ? 28 : 19}, ${info.markerSize === 'large' ? 16 : 14})`}>
        {info.chip?.completed && (
          <>
            <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#1C48CD" stroke="white" />
            <path
              d="M10.5 6.125L7.375 9.25L5.5 7.375"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </>
        )}

        {info.chip?.stacked && (
          <>
            <rect width="16" height="16" rx="8" fill="#FF517B" />
            <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#25282F" stroke-opacity="0.2" />
            <path
              d="M10.9379 7.39967L8.14206 9.25801C8.10039 9.28717 8.05456 9.29967 8.00456 9.29967C7.95456 9.29967 7.91289 9.28717 7.87122 9.26217L4.97122 7.41217L4.39206 7.77051C4.32122 7.81634 4.27539 7.89551 4.27539 7.97884C4.27539 8.06217 4.31706 8.14134 4.38789 8.18717L7.89206 10.4205C7.93372 10.4455 7.97956 10.458 8.02539 10.458C8.07122 10.458 8.12122 10.4455 8.16289 10.4163L11.5212 8.18301C11.5921 8.13717 11.6337 8.05801 11.6296 7.97467C11.6296 7.89134 11.5879 7.81217 11.5171 7.77051L10.9379 7.39551V7.39967Z"
              fill="white"
            />
            <path
              d="M10.9379 9.39089L8.14206 11.2492C8.10039 11.2784 8.05456 11.2909 8.00456 11.2909C7.95456 11.2909 7.91289 11.2784 7.87122 11.2534L4.97122 9.40339L4.39206 9.76172C4.32122 9.80755 4.27539 9.88672 4.27539 9.97005C4.27539 10.0534 4.31706 10.1326 4.38789 10.1784L7.89206 12.4117C7.93372 12.4367 7.97956 12.4492 8.02539 12.4492C8.07122 12.4492 8.12122 12.4367 8.16289 12.4076L11.5212 10.1742C11.5921 10.1284 11.6337 10.0492 11.6296 9.96589C11.6296 9.88255 11.5879 9.80339 11.5171 9.76172L10.9379 9.38672V9.39089Z"
              fill="white"
            />
            <path
              d="M11.5212 5.71623L8.15872 3.55373C8.07956 3.50373 7.97539 3.49956 7.89622 3.55373L4.39206 5.71206C4.32122 5.75789 4.27539 5.83706 4.27539 5.92039C4.27539 6.00373 4.31706 6.08289 4.38789 6.12873L4.76289 6.36623L5.69622 6.96206L7.88789 8.35789C7.92956 8.38289 7.97539 8.39539 8.02122 8.39539C8.06706 8.39539 8.11706 8.38289 8.15872 8.35373L10.2587 6.95789L11.1337 6.37456L11.5171 6.12039C11.5879 6.07456 11.6296 5.99539 11.6254 5.91206C11.6254 5.82873 11.5837 5.74956 11.5129 5.70789L11.5212 5.71623Z"
              fill="white"
            />
          </>
        )}

        {!(info.chip?.completed || info.chip?.stacked) && chipCount(info.chip) === 1 && (
          <>
            <rect x="0.5" y="0.835938" width="15" height="15" rx="7.5" fill="#F8F9FB" stroke="#B2B8CC" />
            <path d="M10.5156 5.6698H5.6875L4.6875 8.24792H11.3281L10.5156 5.6698Z" fill="white" />
            <path d="M11.3281 10.0604H4.6875V11.3885H11.3281V10.0604Z" fill="white" />
          </>
        )}

        {!(info.chip?.completed || info.chip?.stacked) && chipCount(info.chip) === 2 && (
          <>
            <rect x="0.989258" y="0.5" width="26" height="15" rx="7.5" fill="#F8F9FB" stroke="#B2B8CC" />
            <path d="M22.0049 5.33386H17.1768L16.1768 7.91199H22.8174L22.0049 5.33386Z" fill="white" />
            <path d="M22.8174 9.72449H16.1768V11.0526H22.8174V9.72449Z" fill="white" />
          </>
        )}

        {!(info.chip?.completed || info.chip?.stacked) && chipCount(info.chip) === 3 && (
          <>
            <rect x="0.989258" y="0.5" width="37" height="15" rx="7.5" fill="#F8F9FB" stroke="#B2B8CC" />
            <path d="M33.0049 5.33386H28.1768L27.1768 7.91199H33.8174L33.0049 5.33386Z" fill="white" />
            <path d="M33.8174 9.72449H27.1768V11.0526H33.8174V9.72449Z" fill="white" />
          </>
        )}
      </g>

      {!(info.chip?.completed || info.chip?.stacked) &&
        getChipStack(info.chip).map((x, index) => {
          return (
            <g
              key={`gtag${x}${index}`}
              transform={`translate(${(info.markerSize === 'large' ? 30 : 21) + 11 * index}, ${
                info.markerSize === 'large' ? 19 : 17
              })`}
            >
              {x === 'time' && (
                <g transform={'translate(1,0)'}>
                  <path
                    d="M5 10.3359C7.76142 10.3359 10 8.09736 10 5.33594C10 2.57451 7.76142 0.335938 5 0.335938C2.23858 0.335938 0 2.57451 0 5.33594C0 8.09736 2.23858 10.3359 5 10.3359Z"
                    fill="#FFA217"
                  />
                  <path
                    d="M6.5543 7.86773L7.1543 7.18137L5.34521 5.59046V2.60864H4.43157V5.79955C4.43157 5.93137 4.48611 6.0541 4.58611 6.14046L6.5543 7.86773Z"
                    fill="white"
                  />
                </g>
              )}
              {x === 'pickup' && (
                <>
                  <circle cx="5.98926" cy="5.33594" r="5" fill="#13C097" />
                  <path
                    d="M8.70468 4.85466L6.26635 2.43966C6.18468 2.35799 6.07385 2.30549 5.95718 2.31424C5.84051 2.31424 5.72968 2.36091 5.64801 2.44258L3.25635 4.85758L3.8776 5.47299L5.5226 3.81049V8.36049H6.3976V3.80466L8.08635 5.47591L8.70176 4.85466H8.70468Z"
                    fill="white"
                  />
                </>
              )}
              {x === 'delivery' && (
                <>
                  <circle cx="5" cy="5.33594" r="5" fill="#FF7448" />
                  <path
                    d="M7.71542 5.81917L5.27709 8.23417C5.19542 8.31584 5.08459 8.36834 4.96792 8.35959C4.85126 8.35959 4.74042 8.31292 4.65876 8.23125L2.26709 5.81625L2.88834 5.20084L4.53334 6.86334V2.31333H5.40834V6.86917L7.09709 5.19792L7.71251 5.81917H7.71542Z"
                    fill="white"
                  />
                </>
              )}
              {x === 'skill' && (
                <g transform={'translate(1,0)'}>
                  <path d="M7.51562 2.6698H2.6875L1.6875 5.24792H8.32812L7.51562 2.6698Z" fill="white" />
                  <path d="M8.32812 7.06042H1.6875V8.38855H8.32812V7.06042Z" fill="white" />
                  <path
                    d="M9.08722 4.23141C9.0308 4.17839 8.95766 4.15081 8.88244 4.15399H8.50527V2.04456C8.50527 1.38384 7.97765 0.848267 7.32675 0.848267H2.61162C1.96072 0.848267 1.4331 1.38384 1.4331 2.04456V4.15505H1.11758C1.04235 4.15187 0.969218 4.17945 0.9128 4.23247C0.856381 4.2855 0.819814 4.35868 0.8125 4.43822V5.28772C0.821903 5.3715 0.86056 5.4468 0.921158 5.49983C0.981756 5.55285 1.06011 5.57831 1.13743 5.57088H1.2837C1.28056 5.62073 1.27743 5.67058 1.27743 5.72148V7.99317C1.27221 8.22119 1.35266 8.44285 1.50206 8.60935C1.57102 8.68677 1.65355 8.74722 1.74236 8.79283V9.54051C1.74236 9.69747 1.86774 9.82368 2.02132 9.82368H2.85924C3.01387 9.82368 3.1382 9.69641 3.1382 9.54051V8.87873H6.86182V9.54051C6.86182 9.69747 6.98719 9.82368 7.14078 9.82368H7.9787C8.13333 9.82368 8.25766 9.69641 8.25766 9.54051V8.79283C8.34646 8.74722 8.42796 8.68677 8.49796 8.60935C8.64736 8.44391 8.72781 8.22225 8.72259 7.99317V5.72572C8.72259 5.67376 8.71841 5.62179 8.71423 5.56982V5.57194H8.86259C8.94095 5.57937 9.01826 5.55392 9.07886 5.50089C9.13946 5.44786 9.17916 5.3715 9.18752 5.28878V4.43928C9.1802 4.35974 9.14363 4.2855 9.08722 4.23353V4.23141ZM2.5667 3.32252C2.63043 3.17299 2.73386 3.04572 2.86551 2.95663C2.99715 2.86755 3.14969 2.82195 3.30641 2.82407H6.6957C6.85137 2.82195 7.00391 2.86755 7.13555 2.95557C7.2672 3.0436 7.37063 3.1698 7.43436 3.31934L8.03616 5.03319H1.96386L2.56565 3.32358L2.5667 3.32252ZM3.3085 7.86909C3.3085 8.02393 3.29283 8.12574 3.08491 8.14271C2.96372 8.15226 2.74849 8.16498 2.54998 8.16498C2.41729 8.17135 2.28461 8.15862 2.15505 8.12468C1.96803 8.0515 1.92624 7.96242 1.91684 7.81288C1.91057 7.69622 1.91057 7.5785 1.91684 7.46184C1.91475 7.42684 1.91997 7.39078 1.93147 7.35791C1.94296 7.32503 1.96281 7.29639 1.9858 7.27412C2.06416 7.20413 2.19371 7.20625 2.37132 7.27412L3.09536 7.59971C3.1173 7.60926 3.30745 7.69728 3.30745 7.85318V7.86909H3.3085ZM8.08527 7.81182C8.07586 7.96136 8.03198 8.05044 7.84705 8.12362C7.7175 8.15756 7.58377 8.17135 7.45108 8.16392C7.25257 8.16392 7.03839 8.1512 6.91824 8.14165C6.71033 8.12574 6.69361 8.02287 6.69465 7.86803V7.85212C6.69465 7.69622 6.88272 7.6082 6.9057 7.59865L7.62974 7.27306C7.80735 7.20519 7.93691 7.20307 8.01527 7.27306C8.0393 7.29533 8.05706 7.32397 8.06959 7.35685C8.08213 7.38972 8.08736 7.42472 8.08631 7.45972C8.08631 7.4629 8.09571 7.66122 8.08631 7.81076L8.08527 7.81182Z"
                    fill="#406EE2"
                  />
                </g>
              )}
            </g>
          );
        })}

      {info.text && (
        <text
          x={info.markerSize === 'large' ? 21.5 : 16}
          y={info.markerSize === 'large' ? 44 : 37}
          fill={info.textColor || 'white'}
          dominantBaseline="middle"
          textAnchor="middle"
          fontFamily="Noto Sans"
          fontWeight="600"
          fontSize="13"
        >
          {info.text}
        </text>
      )}
    </svg>
  );
};
